import BigNumber from 'bignumber.js'

export { sign } from './sign'

export function toFixed (n, dp = 2) {
  const bn = new BigNumber(n)
  return bn.isNaN() ? null : bn.toFixed(dp)
}
